import { GET_TOP_PRODUCTS, TOP_PRODUCTS_LOADING } from '../actions/types';

const initialState = {
  loading: false,
  products: [],
};

function reducer(state = initialState, action: { type: string; payload?: any }) {
  switch (action.type) {
    case TOP_PRODUCTS_LOADING:
      return { ...state, loading: true };
    case GET_TOP_PRODUCTS:
      return { ...state, loading: false, products: action.payload };
    default:
      return state;
  }
}

export default reducer;
